import React from 'react';
import { BodyText } from '../../../../ui';

export const NaturalHairPrompt = () => (
  <React.Fragment>
    <BodyText appearance="large" style={{ marginBottom: 16 }}>
      Join hundreds of other pros already offering virtual natural hair consultations,
      at-home styling and treatments.
    </BodyText>
    <BodyText appearance="large">
      Only one step to add a virtual service.
    </BodyText>
  </React.Fragment>
);

export const HaircutsPrompt = () => (
  <React.Fragment>
    <BodyText appearance="large" style={{ marginBottom: 16 }}>
      Join hundreds of other pros already offering virtual bang trims,
      beard trims, and haircuts.
    </BodyText>
    <BodyText appearance="large">
      Only one step to add a virtual service.
    </BodyText>
  </React.Fragment>
);

export const EstheticiansPrompt = () => (
  <React.Fragment>
    <BodyText appearance="large" style={{ marginBottom: 16 }}>
      Join hundreds of other pros already offering virtual makeup tutorials
      and skincare consultations.
    </BodyText>
    <BodyText appearance="large">
      Only one step to add a virtual service.
    </BodyText>
  </React.Fragment>
);

export const ColoristPrompt = () => (
  <React.Fragment>
    <BodyText appearance="large" style={{ marginBottom: 16 }}>
      Join hundreds of other pros already offering virtual color consultations
      and color touch-ups.
    </BodyText>
    <BodyText appearance="large">
      Only one step to add a virtual service.
    </BodyText>
  </React.Fragment>
);

export const ConsultationsPrompt = () => (
  <React.Fragment>
    <BodyText appearance="large" style={{ marginBottom: 16 }}>
      Join hundreds of other pros already offering virtual services.
      Help your clients clean up their look or consult with potential
      new clients to grow your business.
    </BodyText>
    <BodyText appearance="large">
      Only one step to add a virtual service.
    </BodyText>
  </React.Fragment>
);
